var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['swatch', { active: _vm.isActive }]},[_c('div',{staticClass:"swatch-bg",style:(_vm.backgroundImgStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }